'use strict'

import Map from 'assets/core/js/module/map'
import Modal from 'assets/core/js/module/modal'
import mapLoader from 'assets/themes/campings/js/module/mapLoader'

export default function (): Map | null | void {
  const modalEl = document.getElementById('modal-map-full')

  if (!modalEl) {
    return
  }

  const modal = new Modal(modalEl)

  let mapInitialized = false
  let mapElement: HTMLElement | null

  modal.element.addEventListener('modal.opened', () => {
    if (!mapElement) {
      return
    }
    mapElement.dispatchEvent(new CustomEvent('product.map.modal.opened'))
  })

  modal.element.addEventListener('modal.closed', () => {
    if (!mapElement) {
      return
    }
    mapElement.dispatchEvent(new CustomEvent('product.map.modal.closed'))
  })

  let map = null

  document.querySelectorAll('.open-map-full').forEach(function (el) {
    el.addEventListener('click', function (this: HTMLElement) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      mapElement = this
      modal.open()

      if (!mapInitialized) {
        mapLoader()
          .then(() => {
            const markerEl = document.getElementById('product-map-marker')

            if (!markerEl) {
              return
            }

            map = new Map(
              '#product-map-full',
              {
                closeButton: true,
                onClose: function () {
                  modal.close()
                },
              },
              [
                {
                  id: 'product-map',
                  latitude: parseFloat(markerEl.getAttribute('data-latitude') as string),
                  longitude: parseFloat(markerEl.getAttribute('data-longitude') as string),
                },
              ]
            )

            mapInitialized = true
          })
          .catch(() => true)
      }
    })
  })

  return map
}
